const _version = "3.5.4"
function version() {
    return _version
}
export default version
